import type {
  FlightContactDetails,
  FlightTravelerInformationWithCompletion,
} from '../types/model'

export const DATE_OF_BIRTH_FORMAT = 'dd MMMM yyyy'
export const MIN_CHILD_AGE = 2
export const MIN_ADULT_AGE = 18
export const MIN_FLIGHT_ADULT_AGE = 12
export const MIN_DRIVER_AGE = 18
export const TRAVELER_DATE_OF_BIRTH_FORMAT = 'dd/MM/yyyy'

export const DEFAULT_TRAVELER_CONTACT_FORM: FlightContactDetails = {
  contactEmail: '',
  phone: {
    code: null,
    number: null,
  },
}

export const DEFAULT_TRAVELER_FORM = {
  passengerType: 'Adult',
  sexOnPassport: 'M',
  passportNumber: '',
  gender: undefined,
  firstName: '',
  middleName: '',
  lastName: '',
  birthDate: '',
  expiryDate: '',
  issueDate: '',
  issuanceCountry: '',
  issuanceLocation: '',
  isCompleted: false,
} satisfies FlightTravelerInformationWithCompletion

export const DEFAULT_HOTEL_LEAD_FORM = {
  firstName: '',
  lastName: '',
  birthDate: '',
  sexOnPassport: undefined,
  country: '',
  contactEmail: '',
  panCompanyName: '',
  phone: {
    code: null,
    number: null,
  },
  panNumber: undefined,
}

export const DEFAULT_HOTEL_GUEST_FORM = {
  firstName: '',
  lastName: '',
  birthDate: '',
  sexOnPassport: undefined,
}

export const PREFERRED_TIME_OPTIONS = [
  '00:00',
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
]

export const PAYMENT_WALLET_REDIRECT_URL = 'https://wallet.tappit.us'

export const MINIMUM_NAME_LENGTH = 2
export const MAXIMUM_NAME_LENGTH = 25
